<template>
  <div class="content">
    <DetailAside
        v-if="$route.name === 'detail'"
        :userDoc2="userDoc2"
        :managerDoc2="managerDoc2"
    ></DetailAside>

    <VueMain class="vue-main" :userDoc2="userDoc2" :managerDoc2="managerDoc2"></VueMain>
  </div>
</template>

<script>
// Main Files
import userDoc2 from '../data/document/openapi.directcloud.yaml';
import managerDoc2 from '../data/document/openapi.manager.directcloud.yaml';

// Components
import HomeAside from './HomeAside';
import VueMain from './VueMain';
import DetailAside from './DetailAside';

export default {
  name: 'VueContent',
  components: {
    HomeAside,
    VueMain,
    DetailAside,
  },
  data: function () {
    return {
      userDoc2,
      managerDoc2,
    };
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;

  .vue-main {
    width: 100%;
    margin: 0 auto;
    max-width: 1100px;
    padding-bottom: 9rem;
  }

  .vue-contents {
    margin-bottom: 150px;
    margin-top: 10px;
    margin-right: 10em;
  }
}

#wrap-anchor {
  margin: 0 auto;

  #anchor-to-top {
    font-size: 14px;
    font-family: 'arial', 'Meiryo', 'MS PGothic', sans-serif !important;
    display: inline-block;
    width: 80px;
    height: 30px;
    position: fixed;
    bottom: 30px;
    right: 0px;
    z-index: 1000;
  }

  :hover {
    cursor: pointer;
  }
}
</style>
